/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var MortarPestleIcon = createIcon({
  name: 'MortarPestleIcon',
  height: 512,
  width: 512,
  svgPath: 'M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default MortarPestleIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/mortar-pestle-icon.js
// module id = 795
// module chunks = 0